import DefaultPopup from '@r1-frontend/ui-react/components/popups/defaultPopup';
import React from 'react';

import PopupContentForError from './popup-content-for-error';
import PopupContentForRemove from './popup-content-for-remove';

const Popup = (
    {
        isPopupOpened,
        onClose,
        onRemove,
        errorText,
    },
) => {
    return (
        <DefaultPopup
            isOpen={isPopupOpened}
            onClose={onClose}
        >
            {
                errorText
                    ? <PopupContentForError
                        errorText={errorText}
                        onClose={onClose}
                    />
                    : <PopupContentForRemove
                        onRemove={onRemove}
                        onClose={onClose}
                    />
            }
        </DefaultPopup>
    );
};

export default Popup;
